<!-- Spacer -->
<div
    class="hippo-vertical-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
